import { render, staticRenderFns } from "./units-modal.vue?vue&type=template&id=9faaceda&"
import script from "./units-modal.vue?vue&type=script&lang=js&"
export * from "./units-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports